import { useState } from "react";

const FIELDS = [["recipient", "Recipient / employee"], ["location", "City / state / PIN"], ["subsidiary", "Subsidiary / company"], ["courier", "Courier / AWB"], ["invoice", "Invoice #"]];
const PAY = [["", "Any payment status"], ["NOT_DUE", "Not due"], ["DUE", "Due"], ["PARTIALLY_PAID", "Partially paid"], ["OVERDUE", "Overdue"], ["PAID", "Paid"]];

/** Extra order filters (recipient, location, subsidiary, courier, invoice #, payment status). Applied on Enter / Apply. */
export function OrderFilters({ value, onChange }) {
  const [draft, setDraft] = useState(value);
  const apply = () => onChange(draft);
  const clear = () => { setDraft({}); onChange({}); };
  const active = Object.values(value).filter(Boolean).length;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="oo-adv-filters">
      {FIELDS.map(([k, l]) => (
        <input key={k} value={draft[k] || ""} placeholder={l} onChange={(e) => setDraft({ ...draft, [k]: e.target.value })} onKeyDown={(e) => e.key === "Enter" && apply()}
          className="h-8 w-40 rounded-md border border-slate-300 px-2 text-xs transition-colors focus:border-sky-500 focus:outline-none" data-testid={`oo-filter-${k}`} />
      ))}
      <select value={draft.payment_status || ""} onChange={(e) => { const d = { ...draft, payment_status: e.target.value }; setDraft(d); onChange(d); }}
        className="h-8 rounded-md border border-slate-300 bg-white px-2 text-xs" data-testid="oo-filter-payment">
        {PAY.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <button onClick={apply} className="h-8 rounded-md bg-slate-900 px-3 text-xs font-semibold text-white transition-colors hover:bg-slate-700" data-testid="oo-filter-apply">Apply</button>
      {active > 0 && <button onClick={clear} className="h-8 rounded-md border border-slate-300 px-3 text-xs font-semibold text-slate-700 hover:bg-slate-100" data-testid="oo-filter-clear">Clear ({active})</button>}
    </div>
  );
}

const TONE = { PAID: "bg-emerald-100 text-emerald-800", OVERDUE: "bg-rose-100 text-rose-800", DUE: "bg-amber-100 text-amber-900", PARTIALLY_PAID: "bg-sky-100 text-sky-800", NOT_DUE: "bg-slate-100 text-slate-700" };

export function PaymentBadge({ status, code }) {
  if (!status) return <span className="text-[11px] text-slate-400">No invoice</span>;
  return <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${TONE[status]}`} data-testid={`oo-pay-${code}`}>{status.replace("_", " ")}</span>;
}
